import { StackProps, VStack } from "@chakra-ui/react";
import useThemeColors from "../../hooks/useThemeColors";

interface CadProps extends StackProps {
  minimal?: boolean;
  hover?: boolean;
}

export default function Cad({
  children,
  h = "full",
  py,
  px,
  minimal = false,
  hover = false,
  ...props
}: CadProps) {
  const colors = useThemeColors();
  return (
    <VStack
      h={h}
      bg={minimal ? "transparent" : colors.background.card}
      borderRadius={minimal ? "none" : "md"}
      boxShadow={minimal ? "none" : "sm"}
      borderWidth={minimal ? 0 : 1}
      borderColor={minimal ? "transparent" : colors.border.primary}
      px={px ? px : [4, 6]}
      align={"stretch"}
      w={"full"}
      py={py ? py : [4, 6]}
      transition="all 0.4s"
      _hover={hover ? {
        shadow: colors.shadow.cardHover,
        transform: "translateY(-2px)",
      } : {}}
      {...props}
    >
      {children}
    </VStack>
  );
}
